import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { MapRespSuccess } from './types';
import { useQueryParams } from '@hooks/queryParams';

export const useGetMap = () => {
  const {
    params: { search, states, stages, divisionIds, builderIds, coordinatorIds, projectManagerIds },
    parseParams,
  } = useQueryParams();

  const queryParams = parseParams(
    { search, states, stages, divisionIds, builderIds, coordinatorIds, projectManagerIds },
    { arrayFormat: 'bracket' },
  );

  const { data, error, isPending } = useQuery<MapRespSuccess, ApiError>({
    queryKey: [...queryKeys.map, queryParams],
    queryFn: () =>
      queryFetch({
        url: `maps/jobs${queryParams}`,
      }),
  });

  return {
    data,
    error,
    isLoading: isPending,
  };
};
